import Seo from "../components/modules/Seo";
import PageHero from "../components/ui/PageHero";
import OurStory from "../components/modules/OurStory";
import VisionMission from "../components/modules/VisionMission";
import DosaFlipChallenge from "../components/modules/DosaFlipChallenge";
import ContactStrip from "../components/modules/ContactStrip";

const objSeo = {
  title: "About Us — Our Story, Vision & Mission | Bit Byte Foods",
  keywords:
    "Bit Byte Foods, about us, our story, Kote Cafe, Idly Dosa Camp, vision, mission, all-natural batter, traditional stone-ground batter, Bagalkot, Karnataka",
  pathSlug: "/aboutus",
  baseUrl: "https://bitbytefoods.com/",
  description:
    "From a college gang to Kote Cafe (formerly Idly Dosa Camp) — learn the story behind Bit Byte Foods, our commitment to tradition and quality, and the vision driving what we make next.",
};

const AboutUs = () => {
  return (
    <div>
      <Seo data={objSeo} />
      <PageHero
        eyebrow="Our Story"
        title="About Bit Byte Foods"
        subtitle="Friendship, passion, and a love for quality food — the story behind every pack."
      />
      <OurStory />
      <VisionMission />
      <DosaFlipChallenge />
      <ContactStrip />
    </div>
  );
};

export default AboutUs;
